import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] text-white pt-16 pb-8" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-111">
          {/* Brand */}
          <div data-id="element-112">
            <a href="#" className="text-2xl font-serif font-bold text-white block mb-6" data-id="element-113">
              新加坡爽吧 <span className="text-[#C9A96E]" data-id="element-114">Shiok8</span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-115">
              新加坡历史最悠久的专业按摩推荐平台，致力于为用户提供高品质、可信赖的按摩服务体验。
            </p>
            <div className="flex space-x-4" data-id="element-116">
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-117">
                <Facebook size={20} data-id="element-118" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-119">
                <Instagram size={20} data-id="element-120" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-121">
                <Twitter size={20} data-id="element-122" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-123">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-124">
              快速链接 (Links)
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-125">
              <li data-id="element-126">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-127">
                  关于我们 (About Us)
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-129">
                  服务项目 (Services)
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-131">
                  技师入驻 (Join Us)
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-133">
                  隐私政策 (Privacy Policy)
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-134">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-135">
              热门服务 (Popular)
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-136">
              <li data-id="element-137">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-138">
                  中式推拿 (Chinese Tuina)
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-140">
                  泰式按摩 (Thai Massage)
                </a>
              </li>
              <li data-id="element-141">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-142">
                  精油SPA (Oil SPA)
                </a>
              </li>
              <li data-id="element-143">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-144">
                  足底按摩 (Foot Reflexology)
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-145">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-146">
              联系我们 (Contact)
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-147">
              <li className="flex items-start" data-id="element-148">
                <MapPin className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-149" />
                <span data-id="element-150">
                  10 Anson Road, International Plaza, Singapore 079903
                </span>
              </li>
              <li className="flex items-center" data-id="element-151">
                <Phone className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-152" />
                <span data-id="element-153">+65 6123 4567</span>
              </li>
              <li className="flex items-center" data-id="element-154">
                <Mail className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-155" />
                <span data-id="element-156">support@shiok8.sg</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 pb-6" data-id="element-157">
          <h4 className="text-sm font-bold text-[#FDF8F0] mb-4 text-center" data-id="element-158">
            友站链接 (Partner Sites)
          </h4>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-400" data-id="element-159">
            <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-160">
              ttvip-64.com
            </a>
            <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-161">
              shiok27.com
            </a>
            <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-162">
              xfy01.net
            </a>
            <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-163">
              sgharem6.net
            </a>
            <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-164">
              qc52.me
            </a>
            <a href="https://sglonelyguy.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-165">
              sglonelyguy.me
            </a>
            <a href="https://ttvip.life/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-166">
              ttvip.life
            </a>
            <a href="https://locanto.space/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-167">
              locanto.space
            </a>
            <a href="https://kkbaby.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-168">
              kkbaby.site
            </a>
            <a href="https://xfy8.com/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-169">
              xfy8.com
            </a>
            <a href="https://sgbeautycastle.live/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-170">
              sgbeautycastle.live
            </a>
            <a href="https://shiok26.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-171">
              shiok26.site
            </a>
            <a href="https://sgharem.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-172">
              sgharem.site
            </a>
            <a href="https://shiok8.xyz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-173">
              shiok8.xyz
            </a>
            <a href="https://geylang777.info/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-174">
              geylang777.info
            </a>
            <a href="https://ttvip-62.site/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-175">
              ttvip-62.site
            </a>
            <a href="https://geylang666.me/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-176">
              geylang666.me
            </a>
            <a href="https://isyou.net/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E] transition-colors" data-id="element-177">
              isyou.net
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-sm text-gray-500" data-id="element-178">
          <p data-id="element-179">© 2003-2026 新加坡爽吧 Shiok8. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}